module.exports = __webpack_public_path__ + "static/media/GDC-App-website-blue.3935cf81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/packages/@ncigdc/theme/images/GDC-App-website-blue.svg
// module id = 1416
// module chunks = 31